export class ExampleAppComponent implements angular.IComponentOptions
{
    controller = ExampleAppController;
    template = require('./example.html')
}

export class ExampleAppController
{
    
}


// WEBPACK FOOTER //
// ./src/example/example-app.component.ts